import React from 'react'
import {GatsbyImage, getImage} from 'gatsby-plugin-image'
import Fade from 'react-reveal/Fade'

const TeamBlock = ({team}) => {

  return (
    <section className="team-block">
      <div className="team-block__inner">
        {
          team.map((el, index) => (
            <div key={index} className="team-block__item">
              <Fade distance='40px' bottom>
                <>
                  <GatsbyImage image={getImage(el.image.localFile)} alt={el.image.altText}/>
                  <div className="team-block__cap">
                    <h4>{el.name}</h4>
                    <span>{el.position}</span>
                  </div>
                </>
              </Fade>
            </div>
          ))
        }
      </div>
    </section>
  );
};

export default TeamBlock;